import { render, staticRenderFns } from "./MoreButton.vue?vue&type=template&id=935ff7c6&"
import script from "./MoreButton.vue?vue&type=script&lang=ts&"
export * from "./MoreButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports